"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ArrowUpIcon = function ArrowUpIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "9",
    height: "14",
    viewBox: "0 0 9 14"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88525 13.7565L8.57666 9.96985C8.7085 9.84534 8.78174 9.65491 8.78174 9.48645C8.78174 9.09827 8.51807 8.84192 8.13721 8.84192C7.94678 8.84192 7.80762 8.90051 7.68311 9.02502L6.15967 10.5997L4.98047 11.9694L5.04639 10.2775V0.865845C5.04639 0.484985 4.77539 0.206665 4.39453 0.206665C4.00635 0.206665 3.73535 0.484985 3.73535 0.865845V10.2775L3.80859 11.9694L2.62939 10.5997L1.10596 9.02502C0.981445 8.90051 0.834961 8.84192 0.651855 8.84192C0.270996 8.84192 0 9.09827 0 9.48645C0 9.65491 0.0805664 9.84534 0.212402 9.96985L3.90381 13.7565C4.1748 14.0421 4.59961 14.0494 4.88525 13.7565Z"
  }));
};
var _default = ArrowUpIcon;
exports.default = _default;